const DEVICE_KEY = 'coconnect_device_id_v1';

export function getDeviceId(): string {
  try {
    let value = localStorage.getItem(DEVICE_KEY);
    if (!value) {
      value = crypto.randomUUID();
      localStorage.setItem(DEVICE_KEY, value);
    }
    return value;
  } catch {
    // A stable per-tab fallback is safer than blocking recovery entirely when
    // localStorage is unavailable. Persisted device enrollment is still required
    // for production certification.
    const key = '__coconnect_ephemeral_device_id__';
    const globalObject = globalThis as any;
    if (!globalObject[key]) globalObject[key] = crypto.randomUUID();
    return globalObject[key];
  }
}
